import { render } from "./LoadingIndicator.vue?vue&type=template&id=5d8449f1&ts=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__